export default function SupplyData({data}) {

    const Tank = ({item, index}) => {
        const hasProbe = item.level != null;
        const realLvl = hasProbe ? Math.min((item.level * 100) / item.full, 100) : null;
        const minLvl = item.min != null && item.full != null ? Math.min((item.min * 100) / item.full, 100) : null;
        const storageLvl = item.storageQty != null ? Math.min((item.storageQty * 100) / item.full, 100) : null;
        const update = item.update ? new Date(item.update).toLocaleString('pl-PL') : null;
        const storageDate = item.storageDate ? new Date(item.storageDate).toLocaleString('pl-PL') : null;
        const clipId = `fill-${index}`;
        const circleClipId = `circle-${index}`;

        const belowMin = hasProbe && (item.level < item.min || (item.storageQty != null && item.storageQty < item.min));
        const hasWater = hasProbe && item.water > 10;
        const isRecent = (date) => date != null && (Date.now() - new Date(date).getTime()) < 10 * 60 * 1000;

        return (
            <div className={`tank${belowMin || hasWater ? ' tank--alert' : ''}`}>
                <svg className="tank-circle" viewBox="0 0 100 100" overflow="visible">
                    <defs>
                        {hasProbe && (
                            <clipPath id={clipId}>
                                <rect x="0" y={100 - realLvl} width="100" height={realLvl}/>
                            </clipPath>
                        )}
                        <clipPath id={circleClipId}>
                            <circle cx="50" cy="50" r="42"/>
                        </clipPath>
                    </defs>
                    <circle cx="50" cy="50" r="42" fill="#f4f4f4"/>
                    {hasProbe && <circle cx="50" cy="50" r="42" fill="rgba(100, 160, 200, 0.4)" clipPath={`url(#${clipId})`}/>}
                    <circle cx="50" cy="50" r="42" stroke="#e0e0e0" strokeWidth="1.5" fill="none"/>
                    {minLvl != null && (
                        <>
                            <line x1="0" y1={100 - minLvl} x2="100" y2={100 - minLvl} stroke="#e74c3c" strokeWidth="1.8" strokeDasharray="3 2" clipPath={`url(#${circleClipId})`}/>
                            <text x="95" y={100 - minLvl - 1.5} className="tank-line-label" fill="#e74c3c">
                                {item.min.toFixed(2)}
                            </text>
                        </>
                    )}
                    {storageLvl != null && (
                        <>
                            <line x1="0" y1={100 - storageLvl} x2="100" y2={100 - storageLvl} stroke="#27ae60" strokeWidth="1.8" strokeDasharray="3 2" clipPath={`url(#${circleClipId})`}/>
                            <text x="95" y={100 - storageLvl - 1.5} className="tank-line-label" fill="#27ae60">
                                {item.storageQty.toFixed(2)}
                            </text>
                        </>
                    )}
                    <text x="50" y="50" className="tank-circle__pct" textAnchor="middle" dominantBaseline="central">
                        {hasProbe ? `${realLvl.toFixed(1)}%` : '—'}
                    </text>
                </svg>
                <h6>{item.name}</h6>
                {update && (
                    <p className="tank-update">
                        pobranie z sond: {update}
                        <span className={`status-dot ${isRecent(item.update) ? 'status-dot--ok' : 'status-dot--bad'}`}/>
                    </p>
                )}
                {storageDate && (
                    <p className="tank-update">
                        pobranie z magazynu: {storageDate}
                        <span className={`status-dot ${isRecent(item.storageDate) ? 'status-dot--ok' : 'status-dot--bad'}`}/>
                    </p>
                )}
                <p><span>Ilość wg. sond:</span> {hasProbe ? `${item.level.toFixed(2)} l` : '—'}</p>
                <p><span>Ilość wg. magazynu:</span> {item.storageQty != null ? `${item.storageQty.toFixed(2)} l` : '—'}</p>
                <p><span>Ilość pozostała:</span> {item.rest != null ? `${item.rest.toFixed(2)} l` : '—'}</p>
                {item.min != null && <p><span>Minimum zbiornika:</span> {item.min.toFixed(2)} l</p>}
                {item.min_critical != null && <p><span>Minimum krytyczne:</span> {item.min_critical.toFixed(2)} l</p>}
                {hasProbe && (
                    <p>
                        <span>Woda:</span>
                        <span className="water-value">
                            {typeof item.water === 'number' && item.water > 0 ? `${item.water.toFixed(2)} l` : null}
                            <span className={`water-dot ${item.water ? 'water-dot--bad' : 'water-dot--ok'}`}/>
                        </span>
                    </p>
                )}
            </div>
        )
    };

    const sortedData = data && [...data].sort((a, b) => {
        const numA = parseInt(a.name.match(/\d+/)?.[0] ?? '0', 10);
        const numB = parseInt(b.name.match(/\d+/)?.[0] ?? '0', 10);
        return numA - numB;
    });

    return (
        <div className="supply-data">
            {sortedData && sortedData.map((item, index) => <Tank key={index} item={item} index={index}/>)}
        </div>
    )
}
